import { Button } from "@nimit9/signet-ui/components/button"
import { createFileRoute, useNavigate, useRouterState } from "@tanstack/react-router"
import { Header } from "@/components/layout/header"
import { PageWrapper } from "@/components/layout/page-wrapper"
import { useUIStore } from "@/store/ui"

export const Route = createFileRoute("/$")({
  component: NotFoundPage,
})

function NotFoundPage() {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const navigate = useNavigate()
  const openCommandPalette = useUIStore((s) => s.openCommandPalette)

  return (
    <>
      <Header title="Page not found" />
      <PageWrapper>
        <div className="flex flex-col items-center justify-center py-24 text-center">
          <p className="text-[64px] font-light leading-none tracking-[-0.04em] text-text-hint">
            404
          </p>
          <p className="mt-6 text-[15px] font-medium text-text-primary">
            We couldn’t find that page
          </p>
          <p className="mt-1 max-w-md text-[13px] text-text-secondary">
            <code className="rounded bg-bg-elevated px-1.5 py-0.5 text-[12px] text-text-muted">
              {pathname}
            </code>{" "}
            doesn’t match any route in the app. It may have moved or never existed.
          </p>
          <div className="mt-6 flex gap-2">
            <Button onClick={() => navigate({ to: "/" })}>Go to dashboard</Button>
            <Button variant="outline" onClick={openCommandPalette}>
              Search (⌘K)
            </Button>
          </div>
        </div>
      </PageWrapper>
    </>
  )
}
